import { ERecipientPhoneRule } from '../types/merchant'

export const DEFAULT_RECIPIENT_PHONE_RULE = ERecipientPhoneRule.NINE_TO_TEN

export const RECIPIENT_PHONE_RULE_OPTIONS: {
  value: ERecipientPhoneRule
  label: string
  description: string
}[] = [
  {
    value: ERecipientPhoneRule.NINE_TO_TEN,
    label: 'ขึ้นต้นด้วย 0 มี 9–10 หลัก (รับเบอร์บ้านได้) · ค่าเริ่มต้น',
    description:
      'ตรวจทุกช่องทาง รวม AI แชตและนำเข้า Excel · ผ่าน: 0812345678, 021234567',
  },
  {
    value: ERecipientPhoneRule.TEN,
    label: 'ขึ้นต้นด้วย 0 มี 10 หลักเท่านั้น (เบอร์มือถือ)',
    description:
      'ตรวจทุกช่องทาง รวม AI แชตและนำเข้า Excel · ผ่าน: 0812345678 · ไม่ผ่าน: 021234567',
  },
]

export const RECIPIENT_PHONE_RULE_MESSAGES: Record<
  ERecipientPhoneRule,
  string
> = {
  [ERecipientPhoneRule.NINE_TO_TEN]:
    'เบอร์ผู้รับต้องขึ้นต้นด้วย 0 และมี 9–10 หลัก',
  [ERecipientPhoneRule.TEN]: 'เบอร์ผู้รับต้องขึ้นต้นด้วย 0 และมี 10 หลัก',
}
